import type { Ref } from 'react';
import { twMerge } from 'tailwind-merge';

import { MARK_PANEL_TITLE } from '../mark-panel.constants';

import MarkEmblem from './mark-emblem';

export interface MarkFloatingButtonProps {
  onClick: () => void;
  className?: string;
  ref?: Ref<HTMLButtonElement>;
  'data-feature-hint-target'?: string;
}

const MarkFloatingButton = ({
  onClick,
  className,
  ref,
  'data-feature-hint-target': featureHintTarget,
}: MarkFloatingButtonProps) => (
  <button
    ref={ref}
    type="button"
    onClick={onClick}
    data-feature-hint-target={featureHintTarget}
    className={twMerge(
      'flex items-center gap-1.5 rounded-full border border-navy-100 bg-navy-50 px-4 py-3 shadow animate-mark-pulse motion-reduce:animate-none',
      className
    )}
  >
    <MarkEmblem className="size-6" />
    <span className="text-lg font-bold text-navy-800">{MARK_PANEL_TITLE}</span>
  </button>
);

export default MarkFloatingButton;
